const StatementResponseType = [
    {
        value : 'quick',
        text : 'Quick response'
    },
    {
        value : 'custom',
        text : 'Custom response'
    },
    {
        value : 'raw',
        text : 'Raw response'
    }
]

export default StatementResponseType;